/** @format */
import { css } from 'styled-components';

import { theme } from '@toucan/client/global/theme';

import { quietText } from '../../../typography';
import { cardHoverLift } from '../../card-hover';

export const styles = css`
    display: flex;
    align-items: baseline;
    flex-wrap: wrap;
    gap: var(--layout-spacing-8);
    height: 100%;
    padding: var(--layout-spacing-16);
    background-color: var(--colors-surface-primary);
    border: 0.1rem solid var(--colors-border-primary);
    border-radius: var(--effects-radius-lg);
    box-shadow: var(--effects-shadow-sm);
    ${cardHoverLift}

    .kit-stat-tile-value {
        ${theme.typography.body_large_highlight}
        font-size: var(--typography-font-size-4xl);
        color: var(--colors-text-secondary);
        white-space: nowrap;
    }

    /*
     * Sits on the value's own baseline rather than under it, so a short
     * label reads as one line with the number — "3 cameras" — and only a
     * longer one wraps onto a line of its own beneath.
     */
    .kit-stat-tile-label {
        ${quietText}
        color: var(--colors-text-tertiary);
    }
`;
